import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { toApiError } from '../utils';

export interface ExportSoilAnalysisParams {
	format: 'pdf' | 'xlsx';
	areaId?: string;
	startDate?: string;
	endDate?: string;
	filter?: string;
	sortAsc?: string | boolean;
	oldest?: boolean;
}

export const useExportSoilAnalysis = () => {
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async ({
			format,
			areaId,
			startDate,
			endDate,
			filter,
			sortAsc,
			oldest,
		}: ExportSoilAnalysisParams) => {
			try {
				const params = new URLSearchParams();
				params.set('format', format);
				if (forBinding) params.set('forBinding', forBinding);
				if (areaId) params.set('areaId', areaId);
				if (startDate) params.set('startDate', startDate);
				if (endDate) params.set('endDate', endDate);
				if (filter) params.set('filter', filter);
				if (sortAsc !== undefined) params.set('sortAsc', String(sortAsc));
				if (oldest !== undefined) params.set('oldest', String(oldest));

				const response = await api.get<Blob>('/soil-analysis/export', {
					params,
					responseType: 'blob',
				});
				const disposition = response.headers['content-disposition'] as string | undefined;
				const filename = disposition?.match(/filename="?([^";]+)"?/i)?.[1];
				return { file: response.data, filename: filename ?? `analises-de-solo.${format}` };
			} catch (error) {
				throw toApiError(error, 'Erro ao exportar análises de solo');
			}
		},
	});
};
